module.exports = __webpack_public_path__ + "df_font03.jpg?88a8870840ad6b9d4d6e464509347547";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/df_font03.jpg
// module id = 52
// module chunks = 0